module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/event2-d11162246e4f44c991191f3165171400.jpg";